import React from 'react';
export type WorkerTab = 'info' | 'training' | 'health';
interface WorkerTabsProps {
  active: WorkerTab;
  onChange: (tab: WorkerTab) => void;
}
const tabs: {
  id: WorkerTab;
  label: string;
}[] = [{
  id: 'info',
  label: 'Anagrafica'
}, {
  id: 'training',
  label: 'Formazione'
}, {
  id: 'health',
  label: 'Sorveglianza sanitaria'
}];
export function WorkerTabs({
  active,
  onChange
}: WorkerTabsProps) {
  return <div className="flex border-b border-slate-200 mb-6" role="tablist" data-id="element-2045" data-mp="j2j0qkozd4bu">
      {tabs.map(tab => <button key={tab.id} type="button" role="tab" aria-selected={active === tab.id} className={`px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-colors duration-150 ${active === tab.id ? 'border-seform-orange text-seform-orange' : 'border-transparent text-slate-500 hover:text-slate-700'}`} onClick={() => onChange(tab.id)} data-id="element-2046" data-mp="e3ftctlj2m0p">
          {tab.label}
        </button>)}
    </div>;
}